import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./Styles";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const ChartTitle = (props) => {
  const { title, subtitle, floating } = props;
  const classes = useStyles();
  const floatingStyle = {
    position: "absolute",
    zIndex: 450,
    background:
      "transparent linear-gradient(180deg, rgba(239, 239, 253, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%) 0% 0% no-repeat padding-box",
  };
  const nonFloatingStyle = { background: "transparent" };
  const { isMobile } = useGetViewPortDimensions();

  return (
    <Box
      className={isMobile ? classes.chartHeaderResponsive : classes.chartHeader}
      style={floating ? floatingStyle : nonFloatingStyle}
    >
      <Typography
        variant="h5"
        component="div"
        className={isMobile ? classes.chartHeaderTitleResponsive : classes.chartHeaderTitle}
      >
        {title}
      </Typography>
      <Typography variant='body1' component="p" className={isMobile ? classes.chartHeaderSubtitleResponsive : classes.chartHeaderSubtitle}>{subtitle}</Typography>
    </Box>
  );
};

ChartTitle.defaultProps = {
  title: "Chart Title",
  subtitle: "Big River Policy Name",
  floating: false,
};

export default ChartTitle;
